module.exports = __webpack_public_path__ + "img/tshirt.f69d5a93.png";